<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训设备入库</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-select v-model="formInline.region" placeholder="请选择组织结构">
            <el-option label="班级一" value="shanghai"></el-option>
            <el-option label="班级二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
          <!-- <el-input v-model="formInline.training_room" clearable :placeholder="`请输入所属${$store.state.themeTitle}室`"></el-input> -->
        </el-form-item>
        <!--<el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训设备导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange(...arguments,'id')">
        <custom-table-column type="selection" width="40">
        </custom-table-column>
        <custom-table-column prop="device_no" label="设备编号" width="150">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="220px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="device_num" label="入库数量" width="100">
        </custom-table-column>
        <custom-table-column prop="remainder_quantity" label="库存数量" width="100">
        </custom-table-column>
        <custom-table-column prop="device_price" label="设备价格（元）" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="province" label="入库人" width="150">
        </custom-table-column> -->
        <custom-table-column prop="created_at" label="入库日期" width="180">
        </custom-table-column>
        <custom-table-column prop="type" label="类型" width="150">
        </custom-table-column>
        <custom-table-column prop="supplier" label="销售商" width="150">
        </custom-table-column>
        <custom-table-column prop="manufacturer" label="制造商" width="150">
        </custom-table-column>
        <custom-table-column prop="usage" label="使用方向" width="150">
        </custom-table-column>
        <custom-table-column prop="place" label="存放地点" width="150">
        </custom-table-column>
        <custom-table-column prop="size" label="规格" width="150">
        </custom-table-column>
        <custom-table-column prop="cc_number" label="设备型号" width="150">
        </custom-table-column>
        <custom-table-column prop="device_model" label="出厂编号" width="150">
        </custom-table-column>
        <custom-table-column prop="keep_man" label="保管人" width="80">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="150">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" width="220">
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="入库人电话" width="120">
        </custom-table-column>
        <custom-table-column prop="email" label="入库人邮箱" width="180">
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleNumbeChange(scope.row.id)" type="text" size="small">库存修改</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
            <el-button @click="handleEdit(scope.row,[ 'created_at','deleted_at','training_room_id','schoolid'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="库存修改" :visible.sync="numberDialogVisible" width="406px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="类  型" prop="type">
          <el-select v-model="ruleForm1.type" style="width:216px;" placeholder="请选择类型">
            <el-option v-for="item in $store.state.mathMethods" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数  量" prop="num">
          <el-input v-model.number="ruleForm1.num" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1',changeDeviceNumber)">确认</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="设备编号" prop="device_no">
          <el-input v-model="ruleForm.device_no" placeholder="请输入设备编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="ruleForm.device_name" placeholder="请输入设备名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备数量" prop="device_num">
          <el-input v-model.number="ruleForm.device_num" :disabled="type=='edit'" placeholder="请输入设备数量" style="width:198px;"></el-input> 个
        </el-form-item>
        <el-form-item label="设备价格" prop="device_price">
          <el-input v-model="ruleForm.device_price" placeholder="请输入设备价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类  型" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入类型" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="销售商" prop="supplier">
          <el-input v-model="ruleForm.supplier" placeholder="请输入销售商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="制造商" prop="manufacturer">
          <el-input v-model="ruleForm.manufacturer" placeholder="请输入制造商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="使用方向" prop="usage">
          <el-input v-model="ruleForm.usage" placeholder="请输入使用方向" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="存放地点" prop="place">
          <el-input v-model="ruleForm.place" placeholder="请输入存放地点" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="规  格" prop="size">
          <el-input v-model="ruleForm.size" placeholder="请输入规格" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="cc_number">
          <el-input v-model="ruleForm.cc_number" placeholder="请输入出厂编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备型号" prop="device_model">
          <el-input v-model="ruleForm.device_model" placeholder="请输入设备型号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="保管人员" prop="keep_man">
          <!-- <el-input v-model="ruleForm.person" placeholder="请输入{{$store.state.themeTitle}}室负责人姓名" style="width:216px;"></el-input> -->
          <el-select v-model="ruleForm.keep_man" clearable style="width:216px;" filterable :loading="loading" remote :remote-method="remoteMethod" placeholder="请选择保管人员">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" :rows="5" placeholder="请输入备注" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData"></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinImport, mixinValidate, mixinOrgan,mixinPrint],
  data() {
    return {
      formInline: {
        device_name: '',
        structure_1: '',
        major: '',
        training_room: '',
      },
      loading: false,
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      total: 40,
      users: [],
      ruleForm: {
        device_no: '',
        device_name: '',
        device_num: 0,
        training_room: '',
        training_no: '',
        device_price: 0,
        supplier: '',
        manufacturer: '',
        type: '',
        usage: '',
        place: '',
        size: '',
        cc_number: '',
        desc: '',
        keep_man: '',
        device_model: '',
      },
      rules: {
        device_no: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        device_num: [
          { required: true, message: '设备数量不能为空' },
          { type: 'number', message: '设备数量必须为数字值' },
        ],
        device_price: [
          { required: true, message: '设备价格不能为空' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        training_no: [{ required: true, message: `请选择所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      rules1: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        num: [
          { required: true, message: '数量不能为空' },
          { type: 'number', message: '数量必须为数字值' },
        ],
      },
      ruleForm1: {
        id: '',
        type: '',
        number: 0,
      },
      numberDialogVisible: false,
      action: '',
      downloadUrl: 'template/实训设备导入模版.xlsx',
      downloadName: '实训设备导入模版.xlsx',
      btnTitle: '导入实训设备数据',
      exportUrl: '',
      exportBtnTitle: '实训设备列表导出',
      downloadName: '实训设备列表.xlsx',
    };
  },
  components: {},
  created() {
    this.action = `${this.baseUrlt}api/device/import`;
    this.exportUrl = `${this.baseUrlt}api/device/devicelistExport`;
    
  },
  mounted() {
    this.$store.dispatch('getTarinMent');
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleNumbeChange(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: '1,2,3,5,6,7,8',
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    async changeDeviceNumber() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.update.changeDeviceNumber(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '库存修改成功！',
        });
        this.ruleForm1 = {
          id: '',
          type: '',
          number: 0,
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    // handleExport(){
    //   this.$message.info('导出中。。。');
    // },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createDeviceInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateDeviceInto() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/device/edit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getDeviceIntoList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createDeviceInto();
          } else if (this.type == 'edit') {
            this.updateDeviceInto();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
